import label from "../../labels/interviewProcess_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";

import html2pdf from "html2pdf.js";
import { CustomPdfDownload } from "../../../common/components/CustomPdfDownload";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getObjectiveStatusflag,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getReservationData,
  calculateCutoff,
  getCutOffCriteria,
  cutOffLockUnlock,
} from "../../actions/interviewProcessActions";

import {
  getYearList,
  getAdvertisementlistByYear,
} from "../../../common/actions/commonActions";
import {
  SET_CUTOFF_CRITERIA,
  SET_RESERVATION_DATA,
  SET_OBJECTIVE_STATUS_DATA,
  SET_OBJECTIVE_STATUS_DATA_FLAG,
} from "../../../common/constants/ActionTypes";

import { getObjectiveStatus } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { toastr } from "react-redux-toastr";



const CutOff = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });

  const [selectedAdvertiseNo, setSelectedAdvertiseNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");

  const [qualifySeatMatrixData, setQualifySeatMatrixData] = useState([]);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const [selectedYear, setSelectedYear] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [unlock, setUnlock] = useState(true);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [subCatDivyang, setSubCatDivyang] = useState([]);
  const [flagArray, setFlagArray] = useState([]);
  const [subCatDivyangCounts, setSubCatDivyangCounts] = useState(0);
  const [showRealStatus, setShowRealStatus] = useState(false);
  const dispatch = useDispatch();

  let { advertisementList, examList, objectiveStatusDataFlag } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let { allReservationData, cutoffCriteria } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );

  useEffect(() => {
    let tempArrCats = [];
    cutoffCriteria?.cutoff?.data
      .filter((item) => item.isDivyang == true && item.subCategory == "DIVYANG")
      .map((item) => {
        let isExist =
          tempArrCats &&
          tempArrCats.length > 0 &&
          tempArrCats.find(
            (itm) => itm.toLowerCase() == item.subSubCategory.toLowerCase()
          );

        if (isExist == false || isExist == undefined) {
          tempArrCats.push(item.subSubCategory.toLowerCase());
        }
      });
    let newArr = [...new Set(tempArrCats)];

    setSubCatDivyang(newArr);
    setSubCatDivyangCounts(newArr.length);
  }, [cutoffCriteria]);

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let { objectiveStatusData } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  useEffect(() => {
    if (allReservationData.criteria) {
      setQualifySeatMatrixData(allReservationData.criteria);
    } else {
      setQualifySeatMatrixData([]);
    }
  }, [allReservationData]);
  useEffect(() => {
    setPrintFlag(qualifySeatMatrixData.length === 0);
  }, [qualifySeatMatrixData]);
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch({
      payload: [],
      type: SET_OBJECTIVE_STATUS_DATA_FLAG,
    });
    flagArray.length = 0;
    dispatch(getYearList());
    setReloadItem(!reloadItem);
  }, []);

  // useEffect(() => {
  //   if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
  //     const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
  //     const flagArrayBeforeInterviewCriteria = [];
  //     for (let i = 0; i < flagValues.length; i++) {
  //       if (flagValues[i] === "Cutoff") {
  //         break;
  //       }

  //       if (objectiveStatusDataFlag[i]?.flagStatus) {
  //         flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);
  //       }
  //     }
  //     setFlagArray(flagArrayBeforeInterviewCriteria);
  //     setFlagArray(visibleFlags);
  //     if (flagArrayBeforeInterviewCriteria.some(item => item.flagStatus === false)) {
  //       toastr.warning(label.UNLOCK_MESSAGE_CUT_OFF);
  //     }
  //   }
  // }, [objectiveStatusDataFlag]);
  useEffect(() => {
    if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
      const visibleFlags = objectiveStatusDataFlag.filter(
        (item) => item.flagStatus === true
      );
      setFlagArray(visibleFlags);
      if (objectiveStatusDataFlag.some(item => item.flagStatus === false)) {
        toastr.warning(label.UNLOCK_MESSAGE_CUT_OFF);
      }
    }
  }, [objectiveStatusDataFlag]);

  const onSelectYear = (ele) => {
    if (ele == "") {
      // onCancelButton();
    } else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }

      setSaveButtonFlag(true);
      setPrintFlag(true);
      setUnlock(true);
      dispatch({
        payload: [],
        type: SET_CUTOFF_CRITERIA,
      });
      setReloadItem(!reloadItem);
      dispatch({
        type: SET_RESERVATION_DATA,
        payload: [],
      });
      dispatch({
        type: SET_OBJECTIVE_STATUS_DATA,
        payload: [],
      });
    }
  };
  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertiseNo(selectedValue);
    setSelectedExam("");
    setConfirmClicked(false);
    setPrintFlag(true);
    examList.length = 0;
    setSaveButtonFlag(true);
    setPrintFlag(true);
    setUnlock(true);
    setQualifySeatMatrixData([]);
    ele && dispatch(getExamslistByAdvertisementId(ele));
    dispatch({
      payload: [],
      type: SET_CUTOFF_CRITERIA,
    });
    setReloadItem(!reloadItem);
  };
  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    Promise.resolve()
      .then(() => {
        return dispatch(getObjectiveStatusflag(selectedValue));
      })
      .then(() => {
        setConfirmClicked(false);
        setPrintFlag(true);
        setUnlock(true);
        setSaveButtonFlag(false);
        setPrintFlag(true);
        setQualifySeatMatrixData([]);
        setReloadItem((prev) => !prev);

        return dispatch({
          payload: [],
          type: SET_CUTOFF_CRITERIA,
        });
      })
      .then(() => {

        if (selectedValue) {
          return dispatch(getObjectiveStatus(selectedValue, setSaveButtonFlag));
        }
        return Promise.resolve();
      })
      .catch((error) => {
        console.error("Error during onExamChange:", error);
      });
  };

  const onCancelButton = () => {
    // setSelectedExam("");
    setConfirmClicked(false);
    setPrintFlag(true);
    setUnlock(true);
    setQualifySeatMatrixData([]);
    setReloadItem(!reloadItem);
    dispatch({
      payload: [],
      type: SET_CUTOFF_CRITERIA,
    });
    dispatch({
      type: SET_OBJECTIVE_STATUS_DATA,
      payload: [],
    });
    examList.length = 0;
    reset();
  };

  const onSubmit = () => {
    // dispatch(getReservationData(selectedExam));
    setPrintFlag(false);
    setUnlock(false);
    // dispatch(getCutOffCriteria(selectedExam, setPrintFlag));
    dispatch(
      getCutOffCriteria(
        selectedExam,
        setPrintFlag,
        setConfirmClicked
      )
    );
    setReloadItem(!reloadItem);
  };

  const handleCalculate = () => {
    dispatch(calculateCutoff(selectedExam));
    // setReloadItem(!reloadItem);
  };

  const onhandleUnlock = (status, lock) => {
    dispatch(
      cutOffLockUnlock(
        selectedExam,
        status,
        lock,
        setUnlock,
        getObjectiveStatus
      )
    );
    setReloadItem(!reloadItem);
  };
  const downloadPdf = () => {
    genPdf();
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };
  const groupByCategory = () => {
    const groupedData = {};
    qualifySeatMatrixData.forEach((item) => {
      const { category, subCategory, cutoff } = item;
      if (!groupedData[category]) {
        groupedData[category] = [];
      }
      groupedData[category].push({ subCategory, cutoff });
    });
    return groupedData;
  };
  const groupedCutOffData = groupByCategory();

  const genPdf = () => {
    let headerDiv =
      ' <div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' +
      label.MPSC +
      "</h5><h5>" +
      cutoffCriteria.examName +
      "</h5></div>";
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;
    htmlContent.style.fontFamily = "Arial, sans-serif";
    htmlContent.style.fontSize = "8px";

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "CutOffList.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 8, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, textX, textY);

          const ad = cutoffCriteria.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.5;
          const headerY = 0.5;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save("CutOffList.pdf");
      });
  };

  useEffect(() => {
    reset();
    onCancelButton();
    dispatch({
      payload: [],
      type: SET_CUTOFF_CRITERIA,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const groupedByPost =
    cutoffCriteria?.cutoff?.data?.reduce((acc, item) => {
      if (!acc[item.postCriteriaId]) {
        acc[item.postCriteriaId] = {
          postName: item.postName,
          postCriteriaId: item.postCriteriaId,
          data: [],
        };
      }

      acc[item.postCriteriaId].data.push(item);

      return acc;
    }, {}) || {};

  const posts = Object.values(groupedByPost);


  return (
    <div>
      {/* <h5> {label.CutOff} </h5> */}

      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    // value={selectedYear}
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option>{element}</option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo1"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo1.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam1"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam1.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>
              <div className="row pl-3 pr-3">
                {flagArray &&
                  flagArray

                    .map((ele, index) => (
                      <div className="d-flex p-2" key={index}>
                        <input
                          type="checkbox"
                          disabled
                          checked={ele.flagStatus === true && true}
                          className="form-control"
                        />
                        <label className="ml-1">{ele.flag}</label>
                      </div>
                    ))}
              </div>
              {/* {objectiveStatusData.flgIsCutoffCalculated === false && (
                <div className="row align-items-center mt-3 mb-3">

                  <div className="col-auto d-flex align-items-center">
                    <label className="mb-0 mr-2 ">
                      Seat Matrix
                    </label>

                    <input
                      type="checkbox"
                      disabled
                      checked={objectiveStatusData.flgSeatMatrixLocked === true}
                    />
                  </div>

                  <div className="col-auto d-flex align-items-center">
                    <label className="mb-0 mr-2 ">
                      Multiple
                    </label>

                    <input
                      type="checkbox"
                      disabled
                      checked={objectiveStatusData.flgMultipleLocked === true}
                    />
                  </div>

                  {objectiveStatusData.flgSeatMatrixLocked &&
                    objectiveStatusData.flgMultipleLocked && (
                      <div className="col-auto">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            handleCalculate();
                          }}
                        >
                          Calculate CutOff
                        </button>
                      </div>
                    )}
                </div>
              )} */}

              <div className="row">
                <div className="form-group col-md-6">
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary" ||
                    session.roleName == "desk officer") && (
                      <>
                        <button
                          type="button"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary mr-1"
                          disabled={saveButtonFlag}
                          hidden={
                            objectiveStatusData.flgIsCutoffCalculated === false
                          }
                          onClick={handleSubmit((e) => {
                            onSubmit(e);
                          })}
                        >
                          {commonLabels.BUTTON_VIEW}
                        </button>{" "}
                      </>
                    )}
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary") && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        disabled={printFlag || !confirmClicked}
                        onClick={() => {
                          downloadPdf();
                        }}
                      >
                        {commonLabels.BUTTON_PRINT}
                      </button>
                    )}

                  {session.roleName == "superadmin" &&
                    objectiveStatusData.flgIsCutoffCalculated === true && (
                      <button
                        type="button"
                        className={`btn mr-2 ${objectiveStatusData.flgIsCutoffCalculated
                          ? "btn-lock-green"
                          : "btn-unlock-red"
                          }`}
                        style={{
                          borderRadius: "0.60rem",
                        }}
                        disabled={unlock}
                        onClick={() => {
                          onhandleUnlock(
                            "cutoff",
                            !objectiveStatusData.flgIsCutoffCalculated
                          );
                        }}
                      >
                        {objectiveStatusData.flgIsCutoffCalculated
                          ? commonLabels.BUTTON_UNLOCK
                          : commonLabels.BUTTON_LOCK}
                      </button>
                    )}
                  {objectiveStatusData.flgIsCutoffCalculated === false &&
                    objectiveStatusData.flgSeatMatrixLocked &&
                    objectiveStatusData.flgMultipleLocked && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCalculate();
                        }}
                      >
                        Calculate CutOff
                      </button>
                    )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {cutoffCriteria?.cutoff?.totalQualifiedCandidate > 0 && (
        // <div ref={pdfRef} className="answerKeyTable" id="cutOff">
        <div ref={pdfRef} id="cutOff">
          {posts.map((post) => {
            const visibleData = post.data.filter((item) => item.counts > 0);

            if (visibleData.length === 0) return null;

            const visibleCategories = [
              ...new Set(visibleData.map((item) => item.category.toUpperCase())),
            ];

            const visibleSubCategories = [
              ...new Set(visibleData.map((item) => item.subCategory.toUpperCase())),
            ];

            return (
              <div key={post.postCriteriaId} className="answerKeyTable">
                <h5 className="text-center font-weight-bold mb-3">
                  {post.postName}
                </h5>

                <div className="table-responsive">
                  <table className="table table-bordered text-center">
                    <thead className="thead-light">
                      <tr>
                        <th>Category</th>

                        {visibleSubCategories.map((subcategory) => (
                          <th key={subcategory} colSpan="3">
                            {subcategory}
                          </th>
                        ))}
                      </tr>

                      <tr>
                        <th></th>

                        {visibleSubCategories.map((subcategory) => (
                          <React.Fragment key={subcategory}>
                            <th>POSTS</th>
                            <th>COUNT</th>
                            <th>CUTOFF MARKS</th>
                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {visibleCategories.map((category) => (
                        <tr key={category}>
                          <td>{category}</td>

                          {visibleSubCategories.map((subcategory) => {
                            const entry = visibleData.find(
                              (item) =>
                                item.category.toUpperCase() === category &&
                                item.subCategory.toUpperCase() === subcategory
                            );

                            if (!entry) {
                              return (
                                <React.Fragment key={subcategory}>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </React.Fragment>
                              );
                            }

                            return (
                              <React.Fragment key={subcategory}>
                                <td>
                                  {category !== "OPEN"
                                    ? `${entry.reservedSeat} * ${entry.multiple} = ${entry.reservedSeat * entry.multiple
                                    }`
                                    : entry.reservedSeat}
                                </td>

                                <td>{entry.counts}</td>

                                <td>{entry.cutOff}</td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
          {cutoffCriteria?.cutoff?.totalQualifiedCandidate > 0 && (
            <div className="d-flex flex-column align-items-center justify-content-center">

              <p className="font-weight-bold fs-5">
                Total No. of Qualified Candidate:{" "}
                {cutoffCriteria?.cutoff?.totalQualifiedCandidate}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CutOff;
